export const NEST_PATH_SEGMENT = 'n';
export const API_PATH_SEGMENT = 'api';
export const MEMBERS_PATH_SEGMENT = 'members';
export const AUTH_PATH_SEGMENT = 'auth';
export const PAYMENT_CARD_TOKENS_PATH_SEGMENT = 'payment-card-tokens';
export const CREDIT_CARD_TOKENS_PATH_SEGMENT = 'credit-card-tokens';
export const CREATE_ACCOUNT_PATH_SEGMENT = 'create-account';
export const TOKENIZE_PATH_SEGMENT = 'tokenize';
export const EXPERIMENTS_PATH_SEGMENT = 'experiments';
export const CLONE_PATH_SEGMENT = 'clone';
export const ZOOZ_PATH_SEGMENT = 'zooz';
export const PUBLIC_KEYS_PATH_SEGMENT = 'public-keys';
export const ENCRYPT_CVV_PATH_SEGMENT = 'encrypt-cvv';
export const CSP_REPORTS_PATH_SEGMENT = 'csp-reports';
export const TRACK_PATH_SEGMENT = 'track';
export const TRACK_UNKNOWN_CHECKOUT_SESSION_PATH_SEGMENT = 'unknown';
export const BLOX_PATH_SEGMENT = 'blox';
export const PAYMENT_DETAILS_CACHE_PATH_SEGMENT = 'payment-details-cache';
